// extracted by mini-css-extract-plugin
export default {"invalidDataError":"addCategoryStyle_invalidDataError__yRYnH"};